import type { FormulaToken } from '../../models/metric.types'

export const METRIC_CHIP_SOURCE = String.raw`\[\[m:([a-zA-Z0-9_.$-]+)\]\]`
export const METRIC_CHIP_RE = new RegExp(METRIC_CHIP_SOURCE, 'gu')
const METRIC_CHIP_TOKEN_SOURCE = String.raw`\[\[m:[a-zA-Z0-9_.$-]+\]\]`

export function tokenize(formula: string): FormulaToken[] {
  const tokens: FormulaToken[] = []
  const token = new RegExp(`${METRIC_CHIP_TOKEN_SOURCE}|\\d+(?:\\.\\d+)?|[+\\-*/()]|\\s+`, 'guy')
  let offset = 0
  while (offset < formula.length) {
    token.lastIndex = offset
    const match = token.exec(formula)
    if (!match) break
    const value = match[0]
    offset = token.lastIndex
    if (/^\s+$/u.test(value)) continue
    if (value.startsWith('[[m:')) tokens.push({ type: 'metric', value })
    else if (/^\d/u.test(value)) tokens.push({ type: 'number', value })
    else if (value === '(') tokens.push({ type: 'lparen', value })
    else if (value === ')') tokens.push({ type: 'rparen', value })
    else tokens.push({ type: 'op', value })
  }
  return tokens
}

export function tokenToPlain(formula: string): string {
  return formula.replace(METRIC_CHIP_RE, '$1')
}
